import * as React from 'react';
import '../css/stepper.sass';

interface StepProps {
  label: string;
  state?: 'active' | 'pending' | 'completed';
  active?: boolean;
  value?: string;
}

export default function Step(props: StepProps) {
  let stepClass = 'step';
  let { state = 'pending'} = props;
  if(props.active){
    state = 'active';
  }
  if (state!=='pending') stepClass = `${stepClass} ${state}`;

  return (
    <div className={stepClass}>
      {props.value && <div className="index-circle">{props.value}</div>}
      <span className="check"></span>
      <span className="label">{props.label}</span>
    </div>
  );
}
